/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BlockRule } from '../models/BlockRule';
import type { BlockRuleUpdateRequest } from '../models/BlockRuleUpdateRequest';
import type { CreateBlockRuleBulkRequest } from '../models/CreateBlockRuleBulkRequest';
import type { CreateBlockRuleRequest } from '../models/CreateBlockRuleRequest';
import type { MyIp } from '../models/MyIp';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class BlockRulesService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Get Block Rules
   * @param slug
   * @returns BlockRule Successful Response
   * @throws ApiError
   */
  public getBlockRulesV1WorkspacesSlugBlockRulesGet(
    slug: string
  ): CancelablePromise<Array<BlockRule>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/block-rules',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Add Block Rule
   * @param slug
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public addBlockRuleV1WorkspacesSlugBlockRulesPost(
    slug: string,
    requestBody: CreateBlockRuleRequest
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/block-rules',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Add Block Rules Bulk
   * @param slug
   * @param requestBody
   * @returns any Successful Response
   * @throws ApiError
   */
  public addBlockRulesBulkV1WorkspacesSlugBlockRulesBulkPost(
    slug: string,
    requestBody: CreateBlockRuleBulkRequest
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/v1/workspaces/{slug}/block-rules/bulk',
      path: {
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Update Block Rule
   * @param id
   * @param slug
   * @param requestBody
   * @returns BlockRule Successful Response
   * @throws ApiError
   */
  public updateBlockRuleV1WorkspacesSlugBlockRulesIdPatch(
    id: number,
    slug: string,
    requestBody: BlockRuleUpdateRequest
  ): CancelablePromise<BlockRule> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/v1/workspaces/{slug}/block-rules/{id}',
      path: {
        id: id,
        slug: slug,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Delete Block Rule
   * @param id
   * @param slug
   * @returns any Successful Response
   * @throws ApiError
   */
  public deleteBlockRuleV1WorkspacesSlugBlockRulesIdDelete(
    id: number,
    slug: string
  ): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/v1/workspaces/{slug}/block-rules/{id}',
      path: {
        id: id,
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get My Ip
   * @param slug
   * @returns MyIp Successful Response
   * @throws ApiError
   */
  public getMyIpV1WorkspacesSlugBlockRulesMyIpGet(slug: string): CancelablePromise<MyIp> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/v1/workspaces/{slug}/block-rules/my-ip',
      path: {
        slug: slug,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
